import React, { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { putMember } from "service/api/member";
import { OneBtnModal } from "components/common/modal";
import { PrimaryBtn } from "components/common/button";
import {
  AccountInfoTable,
  KakaoInfoTable,
  BookmarkTable,
  MemoTable,
} from "components/member/detail";
import type { IMemberDetail } from "service/interface/member";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function MemberDetailPage() {
  const params = useParams();
  const [detailData, setDetailData] = useState<IMemberDetail>(
    {} as IMemberDetail,
  );
  const [isSuccessModalVisible, setIsSuccessModalVisible] =
    useState<boolean>(false);
  const { data } = useSWR(`/admin/manage/user/${params.id}`);

  useEffect(() => {
    if (data) {
      setDetailData((prev) => ({
        ...data.data,
        memo: data.data.Memos[0]?.content,
      }));
    }
  }, [data]);

  const handleSaveBtn = async () => {
    const saveRes = await putMember({
      userId: params.id,
      body: {
        phoneNumber: detailData.phoneNumber,
        email: detailData.email,
        memo: detailData.memo,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    }
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessModalVisible}
        title="저장 완료"
        subTitle="저장이 완료되었습니다."
        btnLabel="확인"
        btnClick={() => {}}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              회원 관리
            </p>
            <PrimaryBtn
              color="white"
              label="저장하기"
              onClick={handleSaveBtn}
            />
          </div>
          <div className="mt-[32px] flex flex-col gap-[56px] rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <AccountInfoTable data={detailData} setData={setDetailData} />
            <KakaoInfoTable data={detailData} />
            <BookmarkTable data={detailData} />
            <MemoTable data={detailData} setData={setDetailData} />
          </div>
        </div>
      </div>
    </>
  );
}
